import { Injectable } from '@angular/core';
import { BcAuth } from 'common/auth/auth.service';

@Injectable()
export class BcSafeSender {
  constructor(private _bcAuth: BcAuth) {
  }

  send(restCall) {
    if (this._bcAuth.isLoggedIn()) {
      return restCall();
    }

    return Promise.resolve({});
  }
}
